import { createFileRoute } from "@tanstack/react-router";
import { AgentWorkflowPage } from "@/components/agent-cli-pages";
import { buildPageHead } from "@/lib/seo-meta";

const path = "/agent/repurpose-content";
export const Route = createFileRoute(path)({
	component: () => <AgentWorkflowPage slug="repurpose-content" />,
	head: ({ matches }) =>
		buildPageHead({
			matches,
			internalPath: path,
			title: "Repurpose Content with an AI Social Media Agent",
			description:
				"Turn a changelog, blog, transcript, demo, or launch note into platform-native social drafts with AgentReacher.",
		}),
});
